import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useClickOutside from '../../hooks/useClickOutside';
import useScrollPosition from '../../hooks/useScrollPosition';
import { NavStyle, NavWrapper, LogoWrapper } from './Navigation.styled';
import { ReactComponent as Logo } from '../../assets/rocketIcon.svg';
import SidebarMenu from '../SidebarMenu/SidebarMenu';
import Burger from '../Burger/Burger';
import Link from '../Link/Link';

const MobileNav = ({ links }) => {
  const [open, setOpen] = useState(false);

  const node = useRef();

  const location = useLocation();

  useClickOutside(node, () => setOpen(false));

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <>
      <Burger open={open} setOpen={setOpen} />
      <SidebarMenu links={links} open={open} onScroll={() => setOpen(false)} />
    </>
  );
};

const DesktopNav = ({ links }) => {
  return (
    <NavStyle>
      <ul>
        {links.map((link) => {
          return (
            <li key={link.path}>
              <Link {...link} />
            </li>
          );
        })}
      </ul>
    </NavStyle>
  );
};

const Navigation = ({ links, isMobile }) => {
  const { scrollY } = useScrollPosition();

  const userScrolled = scrollY > 50;

  return (
    <NavWrapper userScrolled={userScrolled}>
      <LogoWrapper>
        <a href='/'>
          <Logo />
        </a>
      </LogoWrapper>
      {isMobile ? <MobileNav links={links} /> : <DesktopNav links={links} />}
    </NavWrapper>
  );
};

export default Navigation;
